// extracted by mini-css-extract-plugin
module.exports = {"list":"EntitiesList_list__tCteq","section":"EntitiesList_section__88R3D"};